module.exports = __webpack_public_path__ + "static/media/main idea.081cfe56.mp3";